// Look up page-token from <meta> HTML element
const pageTokenElement = document.querySelector('meta[name="x-page-token"]') as HTMLMetaElement

export const pageToken = pageTokenElement?.dataset?.pageToken ?? undefined

export function withPageToken(init: RequestInit): RequestInit {
  const pageTokenHeader = pageToken ? {'X-Page-Token': pageToken} : {}
  return {...init, headers: Object.assign({}, init.headers, pageTokenHeader)}
}
